import { cva } from 'class-variance-authority';

/** Outer container for the time panel — in-flow column that stretches to the calendar's height.
 *  Kept in normal flow (not absolute) so it contributes to the dropdown's measured width;
 *  otherwise the popup positioning under-measures by 160px and the column clips off the
 *  right edge of the viewport (PB-2407). */
export const timePanelContainerClasses =
  'tw:flex tw:flex-col tw:shrink-0 tw:border-l tw:border-solid tw:border-gray-light tw:w-[160px] tw:overflow-hidden';

/** Header label ("Select time") at the top of the time panel. */
export const timePanelHeaderClasses =
  'tw:flex tw:items-center tw:justify-center tw:py-[var(--spacing-small)] tw:border-b tw:border-solid tw:border-gray-light tw:text-14 tw:font-semibold tw:text-font';

/** Body row: scrollable time slots on the left, AM/PM on the right. */
export const timePanelBodyClasses =
  'tw:flex tw:flex-row tw:flex-1 tw:min-h-0';

/** AM/PM toggle — vertical column on the right side of the time panel. */
export const timePeriodToggleClasses =
  'tw:flex tw:flex-col tw:gap-[var(--spacing-micro)] tw:p-[var(--spacing-small)] tw:shrink-0';

/** Individual AM/PM toggle button (CVA with active/inactive state). */
export const timePeriodButtonClasses = cva(
  [
    'tw:flex tw:items-center tw:justify-center',
    'tw:px-[var(--spacing-small)] tw:py-[var(--spacing-small)]',
    'tw:text-14 tw:font-semibold',
    'tw:rounded-[var(--radius-8)] tw:border tw:border-solid',
    'tw:cursor-pointer',
    'tw:transition-colors tw:duration-150',
    'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:focus-visible:ring-inset',
  ].join(' '),
  {
    variants: {
      state: {
        active: 'tw:bg-primary tw:text-white tw:border-primary',
        inactive: 'tw:bg-white tw:text-font tw:border-gray-light tw:hover:bg-gray-lighter',
      },
    },
    defaultVariants: {
      state: 'inactive',
    },
  }
);

/** Scrollable wrapper for the time slot list. */
export const timeSlotScrollClasses = 'tw:flex-1 tw:overflow-y-auto tw:min-h-0 tw:scrollbar-hide';

/** Single-column list inside the scrollable wrapper. */
export const timeSlotListClasses =
  'tw:flex tw:flex-col tw:gap-[var(--spacing-micro)] tw:p-[var(--spacing-small)]';

/** Individual time slot option (CVA with selected/default state). */
export const timeSlotClasses = cva(
  [
    'tw:flex tw:items-center tw:justify-center',
    'tw:py-[var(--spacing-small)]',
    'tw:text-14 tw:font-regular',
    'tw:rounded-[var(--radius-8)] tw:border tw:border-solid',
    'tw:cursor-pointer',
    'tw:transition-colors tw:duration-150',
    'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:focus-visible:ring-inset',
  ].join(' '),
  {
    variants: {
      state: {
        default: 'tw:text-font tw:bg-white tw:border-gray-light tw:hover:bg-gray-lighter',
        selected: 'tw:bg-primary tw:text-white tw:font-semibold tw:border-primary',
        disabled:
          'tw:text-gray tw:bg-gray-lighter tw:border-gray-lighter tw:cursor-not-allowed',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
);
